import { createFileRoute } from "@tanstack/react-router";
import { FromPhotoRecipePage } from "./-FromPhotoRecipePage";

export const Route = createFileRoute("/_app/_recipe-page/recipes/from-photo")({
  component: FromPhotoRecipePage,
});
